import React from "react";
import FormComponent from "./Form";
import { Tab, Tabs } from "react-bootstrap";

const Form = ({ page = "" }) => {
  return (
    <Tabs
      defaultActiveKey="sell"
      id="uncontrolled-tab-example"
      className="mb-3 form-tabs"
    >
      <Tab eventKey="sell" title="Sell Now">
        <FormComponent
          buttonText="Get an offer now"
          placeholderText="Please describe the items you want to sell."
          eventText="form_submit_sell_item"
          event="Sell"
          page={page}
          sellItemDropdown={true}
        />
      </Tab>
      <Tab eventKey="get" title="Get a Loan">
        <FormComponent
          buttonText="Get a loan offer now"
          placeholderText="Please describe your items to keep as collateral."
          eventText="form_submit_collateral_loan"
          event="Get"
          page={page}
        />
      </Tab>
    </Tabs>
  );
};

export default Form;
